interface QueryActivityState {
  isLoading: boolean
  isFetching: boolean
}

export function shouldShowAssociationInitialLoading(
  associationQuery: QueryActivityState,
  hierarchyQuery: QueryActivityState,
): boolean {
  return associationQuery.isLoading || hierarchyQuery.isLoading
}
